// extracted by mini-css-extract-plugin
export default {"adminManager":"AdminManager_adminManager__WbHzj","adminCreateContainer":"AdminManager_adminCreateContainer__CYdHQ"};